(function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var header = navToggle ? navToggle.closest('[data-header]') : document.querySelector('.header-mobile [data-header]');
  var navMenu = document.querySelector('[data-nav-menu]');
  var backdrop = header ? header.querySelector('[data-nav-backdrop]') : document.querySelector('[data-nav-backdrop]');

  function setNavOpen(open) {
    if (!header) return;
    header.classList.toggle('nav-mobile-open', open);
    document.body.classList.toggle('nav-mobile-open', open);
    if (navToggle) navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // nav panel visibility is now driven by CSS transform — do not set hidden
    if (backdrop) backdrop.hidden = !open;
  }

  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      setNavOpen(!header.classList.contains('nav-mobile-open'));
    });
  }
  if (backdrop) {
    backdrop.addEventListener('click', function () { setNavOpen(false); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header && header.classList.contains('nav-mobile-open')) {
      setNavOpen(false);
    }
  });
  if (navMenu) {
    navMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setNavOpen(false); });
    });
  }

  /* Mobile accordion — L1 (exclusive open) */
  document.querySelectorAll('[data-mob-parent]').forEach(function (parent) {
    var trigger = parent.querySelector('[data-mob-trigger]');
    var children = parent.querySelector('.mob-children');
    if (!trigger || !children) return;
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-mob-parent]').forEach(function (other) {
        var otherTrigger = other.querySelector('[data-mob-trigger]');
        var otherChildren = other.querySelector('.mob-children');
        if (otherTrigger && otherChildren && other !== parent) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherChildren.hidden = true;
        }
      });
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      children.hidden = isOpen;
    });
  });

  /* Mobile accordion — L2 (independent) */
  document.querySelectorAll('[data-mob-l2parent]').forEach(function (parent) {
    var trigger = parent.querySelector('[data-mob-trigger-l2]');
    var children = parent.querySelector('.mob-children--l3');
    if (!trigger || !children) return;
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      children.hidden = isOpen;
    });
  });

  function cloneTrackItems(track) {
    if (!track || track.dataset.trackCloned === 'true') return;
    const items = Array.from(track.children);
    if (items.length === 0) return;
    items.forEach(function (item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      track.appendChild(clone);
    });
    track.dataset.trackCloned = 'true';
  }

  document.querySelectorAll('[data-marquee]').forEach(function (marquee) {
    const track = marquee.querySelector('[data-marquee-track]');
    cloneTrackItems(track);
  });

  document.querySelectorAll('[data-reviews-track]').forEach(cloneTrackItems);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-marquee-track]').forEach(cloneTrackItems);
    event.target.querySelectorAll('[data-reviews-track]').forEach(cloneTrackItems);
  });

  const signupForm = document.getElementById('email-signup-form');
  if (signupForm) {
    signupForm.addEventListener('submit', function () {
      const btn = signupForm.querySelector('.email-btn');
      if (btn) btn.disabled = true;
    });
  }

  const filterForm = document.getElementById('CollectionFilters');
  const filterSort = document.querySelector('[data-filter-sort]');

  let filterSnapshot = null;
  let applyingFilters = false;

  function syncFilterPillState(checkbox) {
    const btn = checkbox.nextElementSibling;
    if (btn) btn.classList.toggle('active', checkbox.checked);
  }

  function serializeFilterForm(form) {
    const params = new URLSearchParams();
    form.querySelectorAll('input[type="hidden"]').forEach(function (input) {
      if (input.value) params.append(input.name, input.value);
    });
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      params.append(cb.name, cb.value);
    });
    form.querySelectorAll('.filter-price-field input').forEach(function (input) {
      if (input.value) params.append(input.name, input.value);
    });
    const sort = form.querySelector('[data-filter-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    const query = params.toString();
    window.location.href = query ? form.action + '?' + query : form.action;
  }

  function snapshotFilters(form) {
    filterSnapshot = {
      checkboxes: Array.from(form.querySelectorAll('input[type="checkbox"]')).map(function (cb) {
        return { el: cb, checked: cb.checked };
      }),
      prices: Array.from(form.querySelectorAll('.filter-price-field input')).map(function (input) {
        return { el: input, value: input.value };
      })
    };
  }

  function restoreFilters() {
    if (!filterSnapshot) return;
    filterSnapshot.checkboxes.forEach(function (item) {
      item.el.checked = item.checked;
      syncFilterPillState(item.el);
    });
    filterSnapshot.prices.forEach(function (item) {
      item.el.value = item.value;
    });
  }

  function initFilterForm(root) {
    const scope = root && root.querySelector ? root : document;
    const form = scope.querySelector('#CollectionFilters') || document.getElementById('CollectionFilters') || scope.querySelector('#SearchFilters') || document.getElementById('SearchFilters');
    const modal = scope.querySelector('[data-filter-drawer]') || document.querySelector('[data-filter-drawer]');
    const openBtn = scope.querySelector('[data-filter-open]') || document.querySelector('[data-filter-open]');
    const closeBtn = scope.querySelector('[data-filter-close]') || document.querySelector('[data-filter-close]');
    const sort = scope.querySelector('[data-filter-sort]') || document.querySelector('[data-filter-sort]');

    if (!form || form.dataset.filterInit === 'true') return;
    form.dataset.filterInit = 'true';

    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      syncFilterPillState(cb);
      cb.addEventListener('change', function () {
        syncFilterPillState(cb);
      });
    });

    form.querySelectorAll('[data-filter-uncheck]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const pill = btn.closest('.filter-pill');
        const checkbox = pill ? pill.querySelector('input[type="checkbox"]') : null;
        if (!checkbox || checkbox.disabled) return;
        checkbox.checked = false;
        syncFilterPillState(checkbox);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyingFilters = true;
      serializeFilterForm(form);
    });

    if (sort) {
      sort.addEventListener('change', function () {
        applyingFilters = true;
        serializeFilterForm(form);
      });
    }

    // Tab switching logic for filter drawer
    const tabButtons = modal ? modal.querySelectorAll('.filter-tab-btn') : [];
    const tabPanels = modal ? modal.querySelectorAll('.filter-tab-panel') : [];
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetIndex = btn.dataset.tabIndex;
        tabButtons.forEach(function (b) {
          const active = b.dataset.tabIndex === targetIndex;
          b.classList.toggle('active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        tabPanels.forEach(function (p) {
          const active = p.dataset.panelIndex === targetIndex;
          p.classList.toggle('active', active);
        });
      });
    });

    if (openBtn && modal) {
      openBtn.addEventListener('click', function () {
        applyingFilters = false;
        snapshotFilters(form);
        DrawerSlide.open(modal, 'filter-drawer-open', function () {
          if (closeBtn) closeBtn.focus();
        });
      });
    }

    function closeFilterModal() {
      if (!modal || !modal.open) return;
      if (!applyingFilters) restoreFilters();
      DrawerSlide.close(modal, 'filter-drawer-open', function () {
        applyingFilters = false;
      });
    }

    if (closeBtn && modal) {
      closeBtn.addEventListener('click', closeFilterModal);
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeFilterModal();
      });
      modal.addEventListener('close', function () {
        document.body.classList.remove('filter-drawer-open');
      });
    }
  }

  initFilterForm();
  document.addEventListener('shopify:section:load', function (event) {
    initFilterForm(event.target);
  });

  const GRID_KEY_DESKTOP = 'unsized:grid-columns-desktop';
  const GRID_KEY_MOBILE = 'unsized:grid-columns-mobile';
  const desktopMq = window.matchMedia('(min-width: 768px)');

  function initGridDensity(root) {
    const density = root || document.querySelector('[data-grid-density]');
    const grid = document.querySelector('[data-grid-target]');
    if (!density || !grid) return;

    const defaultDesktop = density.dataset.defaultDesktop || '4';
    const defaultMobile = density.dataset.defaultMobile || '2';
    const slider = density.querySelector('[data-grid-slider]');
    const sliderValue = density.querySelector('[data-grid-slider-value]');
    const toggles = density.querySelectorAll('[data-grid-toggle]');

    function applyColumns(columns) {
      grid.style.setProperty('--cat-grid-columns', String(columns));
      grid.setAttribute('data-columns', String(columns));
    }

    function setMobileToggle(columns) {
      toggles.forEach(function (btn) {
        const active = btn.dataset.gridToggle === String(columns);
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function applyForBreakpoint() {
      if (desktopMq.matches) {
        const stored = localStorage.getItem(GRID_KEY_DESKTOP);
        const columns = stored || defaultDesktop;
        applyColumns(columns);
        if (slider) slider.value = columns;
        if (sliderValue) sliderValue.textContent = columns;
      } else {
        const stored = localStorage.getItem(GRID_KEY_MOBILE);
        const columns = stored || defaultMobile;
        applyColumns(columns);
        setMobileToggle(columns);
      }
    }

    if (slider) {
      slider.addEventListener('input', function () {
        applyColumns(slider.value);
        if (sliderValue) sliderValue.textContent = slider.value;
        localStorage.setItem(GRID_KEY_DESKTOP, slider.value);
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        let columns = btn.dataset.gridToggle;
        if (window.innerWidth < 360 && columns === '4') columns = '2';
        applyColumns(columns);
        setMobileToggle(columns);
        localStorage.setItem(GRID_KEY_MOBILE, columns);
      });
    });

    applyForBreakpoint();
    desktopMq.addEventListener('change', applyForBreakpoint);
  }

  initGridDensity();
  document.addEventListener('shopify:section:load', function (event) {
    initGridDensity(event.target.querySelector('[data-grid-density]'));
  });
})();

/* =============================================
   Mobile tab bar
   ============================================= */
(function () {
  var tabBar = document.querySelector('[data-mobile-tab-bar]');
  if (!tabBar) return;

  var mq = window.matchMedia('(max-width: 767.98px)');

  function setTabBarVisible(visible) {
    if (!mq.matches) return;
    tabBar.hidden = !visible;
    document.body.dataset.tabBarVisible = visible ? 'true' : 'false';
  }

  function updateFromPageState() {
    if (!mq.matches) {
      tabBar.hidden = true;
      document.body.dataset.tabBarVisible = 'false';
      return;
    }
    var stickyVisible = document.body.dataset.pdpStickyVisible === 'true';
    var drawerOpen = document.body.classList.contains('cart-drawer-open')
      || document.body.classList.contains('search-drawer-open')
      || document.body.classList.contains('filter-drawer-open');
    setTabBarVisible(!stickyVisible && !drawerOpen);
  }

  document.addEventListener('pdp-sticky-change', updateFromPageState);

  ['cart-drawer-open', 'search-drawer-open', 'filter-drawer-open'].forEach(function (cls) {
    var observer = new MutationObserver(updateFromPageState);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  });

  mq.addEventListener('change', updateFromPageState);
  updateFromPageState();
})();

/* =============================================
   PDP — Mobile carousel
   ============================================= */
(function initProductCarousel() {
  var carousel = document.querySelector('[data-pdp-carousel]');
  if (!carousel) return;

  var track = carousel.querySelector('[data-pdp-carousel-track]');
  var dots = carousel.querySelectorAll('[data-pdp-carousel-dot]');
  if (!track) return;

  function setActiveDot(index) {
    dots.forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle('active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function scrollToIndex(index) {
    var slide = track.children[index];
    if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    setActiveDot(index);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      scrollToIndex(parseInt(dot.dataset.pdpCarouselDot, 10));
    });
  });

  track.addEventListener('scroll', function () {
    var index = Math.round(track.scrollLeft / track.offsetWidth);
    setActiveDot(index);
  }, { passive: true });

  window.scrollCarouselToMedia = function (mediaId) {
    var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    var index = Array.prototype.indexOf.call(track.children, slide);
    if (index >= 0) scrollToIndex(index);
  };
})();

/* =============================================
   PDP — Sticky bar visibility
   ============================================= */
(function () {
  var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
  var mainAtc = document.querySelector('[data-pdp-add-btn]');
  if (!stickyBar || !mainAtc) return;

  var mq = window.matchMedia('(max-width: 767.98px)');

  function setStickyVisible(visible) {
    if (!mq.matches) {
      stickyBar.hidden = true;
      document.body.dataset.pdpStickyVisible = 'false';
      return;
    }
    stickyBar.hidden = !visible;
    document.body.dataset.pdpStickyVisible = visible ? 'true' : 'false';
    document.dispatchEvent(new CustomEvent('pdp-sticky-change'));
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setStickyVisible(!entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }

  mq.addEventListener('change', function () {
    if (!mq.matches) setStickyVisible(false);
  });
})();

/* =============================================
   PDP — Variant selection
   ============================================= */
(function () {
  var form = document.querySelector('[data-pdp-form]');
  if (!form) return;

  var product = window.__pdp_product;
  if (!product) return;

  var colourGroup = document.querySelector('[data-colour-option-index]');
  var colourOptionIndex = colourGroup ? parseInt(colourGroup.dataset.colourOptionIndex, 10) : 0;

  var selectedOptions = [];

  // Initialise selectedOptions from active pills/swatches
  document.querySelectorAll('[data-pdp-swatch][aria-pressed="true"], [data-pdp-size][aria-pressed="true"]').forEach(function (btn) {
    selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
  });

  // Contract: Liquid must render exactly one swatch and one size pill with
  // aria-pressed="true" so selectedOptions is fully populated on init.
  // Partial selectedOptions will still match (undefined slots are wildcards).
  function findVariant() {
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return selectedOptions[i] === undefined || selectedOptions[i] === opt;
      });
    }) || product.variants[0];
  }

  function updateUI(variant) {
    var idInput = form.querySelector('[data-pdp-variant-id]');
    if (idInput) idInput.value = variant.id;

    document.querySelectorAll('[data-pdp-price]').forEach(function (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    });
    var compareEl = document.querySelector('[data-pdp-compare-price]');
    var saveEl = document.querySelector('[data-pdp-save]');
    if (compareEl && saveEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
        compareEl.style.display = '';
        saveEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
        saveEl.style.display = 'none';
      }
    }

    var addBtn = document.querySelector('[data-pdp-add-btn]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    }

    var stickyAtc = document.querySelector('[data-pdp-add-btn-sticky]');
    if (stickyAtc) {
      stickyAtc.disabled = !variant.available;
      stickyAtc.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    }

    var colourValueEl = document.querySelector('[data-pdp-colour-value]');
    if (colourValueEl && variant.options[colourOptionIndex]) colourValueEl.textContent = variant.options[colourOptionIndex];

    if (typeof window.scrollCarouselToMedia === 'function') {
      var mediaId = (variant.featured_media && variant.featured_media.id) ||
        (variant.featured_image && variant.featured_image.id);
      if (mediaId) window.scrollCarouselToMedia(mediaId);
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function onOptionClick(btn) {
    var index = parseInt(btn.dataset.optionIndex, 10);
    var value = btn.dataset.optionValue;
    selectedOptions[index] = value;

    document.querySelectorAll('[data-pdp-swatch][data-option-index="' + index + '"], [data-pdp-size][data-option-index="' + index + '"]').forEach(function (b) {
      var active = b.dataset.optionValue === value;
      b.setAttribute('aria-pressed', String(active));
      b.classList.toggle('active', active);
    });

    updateUI(findVariant());
  }

  document.querySelectorAll('[data-pdp-swatch], [data-pdp-size]').forEach(function (btn) {
    btn.addEventListener('click', function () { onOptionClick(btn); });
  });
})();

/* =============================================
   PDP — Accordion toggle
   ============================================= */
document.querySelectorAll('[data-pdp-acc-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var bodyId = btn.dataset.body;
    var chevId = btn.dataset.chev;
    var body = document.getElementById(bodyId);
    var chev = document.getElementById(chevId);
    if (!body) return;
    var open = body.classList.contains('open');
    body.classList.toggle('open', !open);
    if (chev) chev.classList.toggle('open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  });
});

document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var bodyId = btn.dataset.body;
    var chevId = btn.dataset.chev;
    var body = document.getElementById(bodyId);
    var chev = document.getElementById(chevId);
    if (!body) return;
    var open = body.classList.contains('open');
    body.classList.toggle('open', !open);
    if (chev) chev.classList.toggle('open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  });
});

/* =============================================
   Drawer slide — shared open/close for cart + search
   ============================================= */
var DrawerSlide = (function () {
  var DURATION_MS = 400;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var triggerElement = null;

  function getPanel(dialog) {
    return dialog.querySelector('.cart-drawer-panel, .search-drawer-panel, .filter-drawer-panel');
  }

  function open(dialog, bodyClass, onOpened) {
    if (!dialog || dialog.open) return;
    triggerElement = document.activeElement;
    dialog.showModal();
    if (bodyClass) document.body.classList.add(bodyClass);
    
    if (dialog.id === 'SearchDrawer') {
      var searchInput = dialog.querySelector('input[type="search"]');
      if (searchInput) setTimeout(function() { searchInput.focus(); }, 50);
    }
    
    if (onOpened) onOpened();
  }

  function close(dialog, bodyClass, onClosed) {
    if (!dialog || !dialog.open) return;
    var panel = getPanel(dialog);
    var finish = function () {
      if (panel) panel.classList.remove('is-closing');
      dialog.close();
      if (bodyClass) document.body.classList.remove(bodyClass);
      
      if (triggerElement && typeof triggerElement.focus === 'function') {
        triggerElement.focus();
        triggerElement = null;
      }
      
      if (onClosed) onClosed();
    };
    if (!panel || reducedMotion) {
      finish();
      return;
    }
    // Trigger exit animation, then close once it finishes.
    panel.classList.add('is-closing');
    var done = false;
    var timer = setTimeout(function () {
      if (done) return;
      done = true;
      finish();
    }, DURATION_MS + 50);
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'transform') return;
      if (done) return;
      done = true;
      clearTimeout(timer);
      panel.removeEventListener('transitionend', onEnd);
      finish();
    });
  }

  return { open: open, close: close };
})();

/* =============================================
   Cart module
   ============================================= */
var Cart = (function () {
  var drawerEl = null;

  function getDrawer() {
    return drawerEl || (drawerEl = document.getElementById('CartDrawer'));
  }

  function open() {
    var d = getDrawer();
    if (!d) return;
    DrawerSlide.open(d, 'cart-drawer-open', function () {
      var closeBtn = d.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    var d = getDrawer();
    if (!d || !d.open) return;
    DrawerSlide.close(d, 'cart-drawer-open');
  }

  function refresh() {
    return fetch('/cart?sections=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var d = getDrawer();
          if (d) {
            var body = d.querySelector('[data-cart-drawer-body]');
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-drawer'];
            var inner = tmp.querySelector('.cart-drawer-section');
            if (body && inner) body.innerHTML = inner.innerHTML;
          }
        }
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-badge]').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
        var drawerCount = document.querySelector('[data-cart-drawer-count]');
        if (drawerCount) {
          drawerCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        }
        var drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
        if (drawerSubtotal) {
          drawerSubtotal.textContent = formatCartMoney(cart.total_price);
        }
        var pageSubtotal = document.querySelector('[data-cart-page-subtotal]');
        if (pageSubtotal) pageSubtotal.textContent = formatCartMoney(cart.total_price);
        updateCartPageSummary(cart);
        updateDrawerFooter(cart);
        initDrawerInteractions();
        initPageInteractions();
      });
  }

  function showDrawerError(msg) {
    var err = document.querySelector('[data-cart-drawer-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
    setTimeout(function () { err.hidden = true; err.textContent = ''; }, 4000);
  }

  function add(variantIds, triggerBtn) {
    var ids = Array.isArray(variantIds) ? variantIds : [variantIds];
    var items = ids.filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    if (!items.length) return Promise.resolve();
    var origText = triggerBtn ? triggerBtn.textContent : '';
    if (triggerBtn) { triggerBtn.disabled = true; triggerBtn.textContent = '\u2026'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'HTTP ' + r.status); });
        return r.json();
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        open();
        if (triggerBtn) { triggerBtn.disabled = false; triggerBtn.textContent = origText; }
      })
      .catch(function (err) {
        if (triggerBtn) { triggerBtn.disabled = false; triggerBtn.textContent = origText; }
        var msg = err && err.message ? err.message : 'Could not add to bag.';
        if (triggerBtn) {
          var origLabel = triggerBtn.textContent;
          triggerBtn.textContent = msg;
          setTimeout(function () { triggerBtn.textContent = origLabel; }, 3000);
        }
      });
  }

  function change(key, qty, qtyEl) {
    var prev = qtyEl ? parseInt(qtyEl.textContent, 10) : qty;
    if (qtyEl) qtyEl.textContent = qty;
    
    var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
    cartEls.forEach(function(el) { el.classList.add('is-loading'); });
    
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () { return refresh(); })
      .catch(function () {
        if (qtyEl) qtyEl.textContent = prev;
        showDrawerError('Could not update quantity.');
        var pageErr = document.querySelector('[data-cart-page-error]');
        if (pageErr) { pageErr.textContent = 'Could not update quantity.'; pageErr.hidden = false; }
      })
      .finally(function() {
        var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
        cartEls.forEach(function(el) { el.classList.remove('is-loading'); });
      });
  }

  function initDrawerInteractions() {
    var d = getDrawer();
    if (!d) return;

    d.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
      if (btn.dataset.cartQtyInit) return;
      btn.dataset.cartQtyInit = '1';
      btn.addEventListener('click', function () {
        var key = btn.dataset.itemKey;
        var item = btn.closest('[data-cart-item]');
        var qtyEl = item ? item.querySelector('[data-cart-qty-value]') : null;
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var next = Math.max(0, current - 1);
        change(key, next, qtyEl).then(function () {
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        }).then(function (r) { return r.json(); }).then(function (c) {
          if (c.item_count === 0) updateDrawerFooter(c);
        });
      });
    });

    d.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
      if (btn.dataset.cartQtyInit) return;
      btn.dataset.cartQtyInit = '1';
      btn.addEventListener('click', function () {
        var key = btn.dataset.itemKey;
        var item = btn.closest('[data-cart-item]');
        var qtyEl = item ? item.querySelector('[data-cart-qty-value]') : null;
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        change(key, current + 1, qtyEl);
      });
    });

    d.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      if (btn.dataset.cartRemoveInit) return;
      btn.dataset.cartRemoveInit = '1';
      btn.addEventListener('click', function () {
        change(btn.dataset.itemKey, 0, null).then(function () {
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        }).then(function (r) { return r.json(); }).then(function (c) {
          if (c.item_count === 0) updateDrawerFooter(c);
        });
      });
    });
  }

  function initPageInteractions() {
    document.querySelectorAll('[data-cart-page-items] [data-cart-qty-minus]').forEach(function (btn) {
      if (btn.dataset.cartQtyInit) return;
      btn.dataset.cartQtyInit = '1';
      btn.addEventListener('click', function () {
        var key = btn.dataset.itemKey;
        var item = btn.closest('[data-cart-item]');
        var qtyEl = item ? item.querySelector('[data-cart-qty-value]') : null;
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        change(key, Math.max(0, current - 1), qtyEl).then(function () {
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        }).then(function (r) { return r.json(); }).then(function (c) {
          if (c.item_count === 0) window.location.reload();
        });
      });
    });

    document.querySelectorAll('[data-cart-page-items] [data-cart-qty-plus]').forEach(function (btn) {
      if (btn.dataset.cartQtyInit) return;
      btn.dataset.cartQtyInit = '1';
      btn.addEventListener('click', function () {
        var key = btn.dataset.itemKey;
        var item = btn.closest('[data-cart-item]');
        var qtyEl = item ? item.querySelector('[data-cart-qty-value]') : null;
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        change(key, current + 1, qtyEl);
      });
    });

    document.querySelectorAll('[data-cart-page-items] [data-cart-remove]').forEach(function (btn) {
      if (btn.dataset.cartRemoveInit) return;
      btn.dataset.cartRemoveInit = '1';
      btn.addEventListener('click', function () {
        var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
        cartEls.forEach(function(el) { el.classList.add('is-loading'); });
        change(btn.dataset.itemKey, 0, null).then(function () {
          var pageItems = document.querySelector('[data-cart-page-items]');
          var pageSubtotal = document.querySelector('[data-cart-page-subtotal]');
          if (pageItems) {
            fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                if (c.item_count === 0) window.location.reload();
                if (pageSubtotal) pageSubtotal.textContent = formatCartMoney(c.total_price);
              });
          }
        }).finally(function() {
          cartEls.forEach(function(el) { el.classList.remove('is-loading'); });
        });
      });
    });

    var discountRoot = document.querySelector('[data-cart-discount]');
    if (discountRoot && !discountRoot.dataset.cartDiscountInit) {
      discountRoot.dataset.cartDiscountInit = '1';

      var input = discountRoot.querySelector('[data-cart-discount-input]');
      var applyBtn = discountRoot.querySelector('[data-cart-discount-apply]');

      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          applyDiscount(input ? input.value : '');
        });
      }

      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyDiscount(input.value);
          }
        });
      }

      discountRoot.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-discount-remove]');
        if (removeBtn) removeDiscount();
      });
    }
  }

  function getDiscountRoot() {
    return document.querySelector('[data-cart-discount]');
  }

  function cartLevelDiscountTotal(cart) {
    var apps = cart.cart_level_discount_applications || [];
    return apps.reduce(function (sum, da) {
      return sum + (da.total_allocated_amount || 0);
    }, 0);
  }

  function updateCartPageSummary(cart) {
    var root = getDiscountRoot();
    if (!root) return;

    var list = root.querySelector('[data-cart-discount-list]');
    if (!list) return;

    var lineNoteText = root.dataset.lineItemNote || '';
    list.innerHTML = '';

    (cart.cart_level_discount_applications || []).forEach(function (da) {
      var row = document.createElement('div');
      row.className = 'cart-discount-row' + (da.type === 'discount_code' ? '' : ' cart-discount-row--automatic');
      row.dataset.discountType = da.type;

      var title = document.createElement('span');
      title.className = 'cart-discount-title';
      title.textContent = da.title;

      var end = document.createElement('span');
      end.className = 'cart-discount-row-end';

      var amount = document.createElement('span');
      amount.className = 'cart-discount-amount';
      amount.textContent = '-' + formatCartMoney(da.total_allocated_amount || 0);
      end.appendChild(amount);

      if (da.type === 'discount_code') {
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-discount-remove';
        removeBtn.dataset.cartDiscountRemove = '';
        removeBtn.textContent = 'Remove';
        var removeLabelTpl = root.dataset.discountRemoveLabel || 'Remove discount __CODE__';
        removeBtn.setAttribute('aria-label', removeLabelTpl.replace('__CODE__', da.title));
        end.appendChild(removeBtn);
      }

      row.appendChild(title);
      row.appendChild(end);
      list.appendChild(row);
    });

    var levelTotal = cartLevelDiscountTotal(cart);
    if ((cart.total_discount || 0) > levelTotal && lineNoteText) {
      var note = document.createElement('p');
      note.className = 'cart-discount-line-note';
      note.dataset.cartDiscountLineNote = '';
      note.textContent = lineNoteText;
      list.appendChild(note);
    }

    var pageSubtotal = document.querySelector('[data-cart-page-subtotal]');
    if (pageSubtotal) pageSubtotal.textContent = formatCartMoney(cart.total_price);

    var drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
    if (drawerSubtotal) drawerSubtotal.textContent = formatCartMoney(cart.total_price);
  }

  function showPageError(msg) {
    var err = document.querySelector('[data-cart-page-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function clearPageError() {
    var err = document.querySelector('[data-cart-page-error]');
    if (!err) return;
    err.textContent = '';
    err.hidden = true;
  }

  function setDiscountControlsDisabled(disabled) {
    var root = getDiscountRoot();
    if (!root) return;
    var input = root.querySelector('[data-cart-discount-input]');
    var apply = root.querySelector('[data-cart-discount-apply]');
    if (input) input.disabled = disabled;
    if (apply) apply.disabled = disabled;
  }

  function discountIsApplied(cart, code) {
    var needle = code.toLowerCase();
    return (cart.cart_level_discount_applications || []).some(function (da) {
      return da.type === 'discount_code' && da.title && da.title.toLowerCase() === needle;
    });
  }

  function applyDiscount(code) {
    var root = getDiscountRoot();
    if (!root) return Promise.resolve();

    var trimmed = (code || '').trim();
    if (!trimmed) {
      showPageError(root.dataset.errorEmpty || 'Enter a discount code');
      return Promise.resolve();
    }

    clearPageError();
    setDiscountControlsDisabled(true);

    var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
    cartEls.forEach(function(el) { el.classList.add('is-loading'); });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: trimmed })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!discountIsApplied(cart, trimmed)) {
          showPageError(root.dataset.errorInvalid || 'Invalid or inapplicable discount code');
          updateCartPageSummary(cart);
          return cart;
        }
        updateCartPageSummary(cart);
        return cart;
      })
      .catch(function () {
        showPageError(root.dataset.errorApply || 'Could not apply discount. Try again.');
      })
      .finally(function () {
        setDiscountControlsDisabled(false);
        var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
        cartEls.forEach(function(el) { el.classList.remove('is-loading'); });
      });
  }

  function removeDiscount() {
    var root = getDiscountRoot();
    if (!root) return Promise.resolve();

    clearPageError();
    setDiscountControlsDisabled(true);

    var cartEls = document.querySelectorAll('[data-cart-drawer-body], [data-cart-page-items]');
    cartEls.forEach(function(el) { el.classList.add('is-loading'); });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartPageSummary(cart);
        var input = root.querySelector('[data-cart-discount-input]');
        if (input) input.value = '';
        return cart;
      })
      .catch(function () {
        showPageError(root.dataset.errorRemove || 'Could not remove discount. Try again.');
      })
      .finally(function () {
        setDiscountControlsDisabled(false);
      });
  }

  function formatCartMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function updateDrawerFooter(cart) {
    var footer = document.querySelector('[data-cart-drawer-footer]');
    if (!footer) return;
    if (cart.item_count === 0) {
      footer.innerHTML =
        '<a href="/collections/all" class="btn-s btn-s--dark cart-empty-cta">' +
        'Continue Shopping</a>';
    } else {
      footer.innerHTML =
        '<div class="cart-drawer-error" data-cart-drawer-error aria-live="polite" hidden></div>' +
        (cart.total_discount > 0 ? 
          '<div class="cart-drawer-subtotal cart-drawer-savings" style="color: var(--success, var(--color-sale))">' +
          '<span class="cart-drawer-subtotal-label">Total Savings</span>' +
          '<span class="cart-drawer-subtotal-price">-' + formatCartMoney(cart.total_discount) + '</span></div>' 
        : '') +
        '<div class="cart-drawer-subtotal">' +
        '<span class="cart-drawer-subtotal-label">Subtotal</span>' +
        '<span class="cart-drawer-subtotal-price" data-cart-drawer-subtotal">' +
        formatCartMoney(cart.total_price) + '</span></div>' +
        '<div class="cart-drawer-actions">' +
        '<a href="/cart" class="btn-s cart-drawer-view-cart">View Bag</a>' +
        '<a href="/checkout" class="btn-s btn-s--dark cart-drawer-checkout">Checkout</a>' +
        '</div>';
    }
  }

  function init() {
    var d = getDrawer();
    if (d) {
      var closeBtn = d.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      d.addEventListener('click', function (e) { if (e.target === d) close(); });
      d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      d.addEventListener('close', function () {
        document.body.classList.remove('cart-drawer-open');
        var panel = d.querySelector('.cart-drawer-panel');
        if (panel) panel.classList.remove('is-closing');
      });
      initDrawerInteractions();
    }

    var pdpForm = document.querySelector('[data-pdp-form]');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = pdpForm.querySelector('[data-pdp-variant-id]');
        var addBtn = pdpForm.querySelector('[data-pdp-add-btn]');
        if (!idInput || !idInput.value) return;
        add([idInput.value], addBtn);
      });
    }

    document.querySelectorAll('[data-pair-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        add([btn.dataset.variantId], btn);
      });
    });

    document.querySelectorAll('[data-pair-add-all]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        add(btn.dataset.variantIds.split(','), btn);
      });
    });

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
      if (trigger.dataset.cartDrawerTriggerInit === 'true') return;
      trigger.dataset.cartDrawerTriggerInit = 'true';
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    initPageInteractions();
  }

  return {
    add: add,
    change: change,
    refresh: refresh,
    open: open,
    close: close,
    init: init,
    applyDiscount: applyDiscount,
    removeDiscount: removeDiscount
  };
})();

Cart.init();

/* =============================================
   Search — Predictive search drawer + expand bar
   ============================================= */
var Search = (function () {
  var drawerEl = null;
  var drawerInput = null;
  var resultsEl = null;
  var footerEl = null;
  var viewAllEl = null;
  var strings = {};
  var searchBaseUrl = '/search';
  var debounceTimer = null;
  var abortController = null;
  var lastTrigger = null;
  var expandOpen = false;
  var desktopMq = window.matchMedia('(min-width: 768px)');

  var MIN_QUERY = 2;
  var DEBOUNCE_MS = 300;

  function getDrawer() {
    if (drawerEl) return drawerEl;
    drawerEl = document.getElementById('SearchDrawer');
    if (!drawerEl) return null;
    drawerInput = drawerEl.querySelector('[data-search-input]');
    resultsEl = drawerEl.querySelector('[data-search-results]');
    footerEl = drawerEl.querySelector('[data-search-footer]');
    viewAllEl = drawerEl.querySelector('[data-search-view-all]');
    strings = {
      prompt: drawerEl.dataset.prompt || 'Start typing to search products',
      loading: drawerEl.dataset.loading || 'Searching…',
      error: drawerEl.dataset.error || 'Search unavailable. Try again.',
      noResults: drawerEl.dataset.noResults || 'No products found for "__QUERY__".',
      viewAll: drawerEl.dataset.viewAll || 'View all results'
    };
    searchBaseUrl = drawerEl.dataset.searchUrl || '/search';
    return drawerEl;
  }

  function formatSearchMoney(priceStr) {
    var n = parseFloat(priceStr);
    if (isNaN(n)) return '';
    return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function noResultsText(query) {
    return strings.noResults.replace('__QUERY__', query);
  }

  function navigateToSearch(query) {
    var q = (query || '').trim();
    if (!q) return;
    window.location.href = searchBaseUrl + '?q=' + encodeURIComponent(q);
  }

  function updateViewAllHref(query, container) {
    var link = container
      ? container.querySelector('[data-search-view-all], .search-expand-view-all')
      : viewAllEl;
    if (!link) return;
    var q = (query || '').trim();
    link.href = q ? searchBaseUrl + '?q=' + encodeURIComponent(q) : searchBaseUrl;
  }

  function thumbImageUrl(url) {
    if (!url || /[?&]width=/i.test(url)) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=128';
  }

  function buildResultRow(product) {
    var url = product.url || '#';
    var title = escapeHtml(product.title || '');
    var price = formatSearchMoney(product.price);
    var imgHtml = '<span class="search-result-thumb"><i class="ti ti-shirt" aria-hidden="true"></i></span>';
    if (product.featured_image) {
      var imgUrl = typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image.url;
      var alt = (product.featured_image && product.featured_image.alt) || product.title || '';
      if (imgUrl) {
        imgUrl = thumbImageUrl(imgUrl);
        imgHtml = '<img class="search-result-thumb" src="' + imgUrl + '" alt="' + escapeHtml(alt) + '" width="64" height="64" loading="lazy">';
      }
    }
    return '<li><a class="search-result-row" href="' + url + '">' +
      imgHtml +
      '<span class="search-result-info"><span class="search-result-title">' + title + '</span>' +
      (price ? '<span class="search-result-price">' + price + '</span>' : '') +
      '</span></a></li>';
  }

  function renderProducts(products, container, query) {
    if (!container) return;
    clearLoadingState(container);
    if (!products.length) {
      container.innerHTML = '<p class="search-drawer-empty">' + noResultsText(query) + '</p>';
      return;
    }
    var html = '<ul class="search-results-list" role="list">';
    products.forEach(function (p) { html += buildResultRow(p); });
    html += '</ul>';
    container.innerHTML = html;
  }

  function showPrompt(container) {
    if (!container) return;
    clearLoadingState(container);
    container.innerHTML = '<p class="search-drawer-prompt" data-search-prompt>' + strings.prompt + '</p>';
  }

  function clearLoadingState(container) {
    if (container) container.classList.remove('is-search-loading');
  }

  function showLoading(container) {
    if (!container) return;
    if (container.querySelector('.search-results-list')) {
      container.classList.add('is-search-loading');
      return;
    }
    clearLoadingState(container);
    container.innerHTML = '<p class="search-drawer-loading"><span class="search-spinner" aria-hidden="true"></span>' + strings.loading + '</p>';
  }

  function showError(container) {
    if (!container) return;
    clearLoadingState(container);
    var hasResults = container.querySelector('.search-results-list');
    if (hasResults) {
      var existing = container.querySelector('.search-drawer-error-msg');
      if (!existing) {
        var err = document.createElement('p');
        err.className = 'search-drawer-error-msg';
        err.textContent = strings.error;
        container.insertBefore(err, container.firstChild);
        setTimeout(function () { err.remove(); }, 4000);
      }
      return;
    }
    container.innerHTML = '<p class="search-drawer-error-msg">' + strings.error + '</p>';
    setTimeout(function () {
      if (container.querySelector('.search-drawer-error-msg') && !container.querySelector('.search-results-list')) {
        showPrompt(container);
      }
    }, 4000);
  }

  function setFooterVisible(visible, container) {
    if (container) {
      var dropdown = container.matches('[data-search-expand-dropdown]')
        ? container
        : (function () {
            var expand = container.closest('[data-search-expand]');
            return expand && expand.querySelector('[data-search-expand-dropdown]');
          })();
      if (dropdown) {
        var existing = dropdown.querySelector('.search-expand-view-all');
        if (visible && !existing) {
          var a = document.createElement('a');
          a.className = 'search-expand-view-all';
          a.textContent = strings.viewAll;
          a.href = searchBaseUrl;
          dropdown.appendChild(a);
        } else if (!visible && existing) {
          existing.remove();
        }
      }
      return;
    }
    if (footerEl) footerEl.hidden = !visible;
  }

  function fetchSuggestions(query, container) {
    var q = (query || '').trim();
    if (q.length < MIN_QUERY) {
      if (abortController) { abortController.abort(); abortController = null; }
      showPrompt(container);
      setFooterVisible(false, container);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();

    showLoading(container);
    setFooterVisible(true, container);
    updateViewAllHref(q, container);

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6';

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: abortController.signal
    })
      .then(function (r) {
        if (r.status === 422) {
          showPrompt(container);
          return null;
        }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderProducts(products, container, q);
        updateViewAllHref(q, container);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showError(container);
      });
  }

  function debouncedFetch(query, container) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchSuggestions(query, container);
    }, DEBOUNCE_MS);
  }

  function onInput(input, container) {
    if (!input) return;
    input.addEventListener('input', function () {
      debouncedFetch(input.value, container);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        navigateToSearch(input.value);
      }
    });
  }

  function open() {
    var d = getDrawer();
    if (!d) return;
    DrawerSlide.open(d, 'search-drawer-open', function () {
      if (drawerInput) {
        drawerInput.value = '';
        showPrompt(resultsEl);
        setFooterVisible(false);
        drawerInput.focus();
      }
      var trigger = document.querySelector('[data-search-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    });
  }

  function close() {
    var d = getDrawer();
    if (!d || !d.open) return;
    if (abortController) { abortController.abort(); abortController = null; }
    clearTimeout(debounceTimer);
    var trigger = lastTrigger || document.querySelector('[data-search-trigger]');
    DrawerSlide.close(d, 'search-drawer-open', function () {
      if (drawerInput) drawerInput.value = '';
      showPrompt(resultsEl);
      setFooterVisible(false);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  }

  function isExpandMode() {
    var header = document.querySelector('.header-desktop [data-header]');
    return header && header.dataset.searchDesktopStyle === 'expand' && desktopMq.matches;
  }

  function openExpand(trigger) {
    var wrap = document.querySelector('[data-search-expand]');
    var input = document.querySelector('[data-search-expand-input]');
    var dropdown = document.querySelector('[data-search-expand-dropdown]');
    if (!wrap || !input || !dropdown) { open(); return; }
    expandOpen = true;
    wrap.hidden = false;
    wrap.classList.add('is-open');
    dropdown.hidden = false;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', 'SearchExpandDropdown');
    }
    showPrompt(dropdown);
    setFooterVisible(false, dropdown);
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeExpand() {
    var wrap = document.querySelector('[data-search-expand]');
    var input = document.querySelector('[data-search-expand-input]');
    var dropdown = document.querySelector('[data-search-expand-dropdown]');
    if (!wrap) return;
    expandOpen = false;
    wrap.classList.remove('is-open');
    wrap.hidden = true;
    if (dropdown) {
      dropdown.hidden = true;
      showPrompt(dropdown);
    }
    if (input) input.value = '';
    if (abortController) { abortController.abort(); abortController = null; }
    clearTimeout(debounceTimer);
    var trigger = document.querySelector('[data-search-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-controls');
    }
  }

  function handleTriggerClick(e) {
    e.preventDefault();
    lastTrigger = e.currentTarget;
    if (isExpandMode()) {
      if (expandOpen) closeExpand();
      else openExpand(lastTrigger);
    } else {
      open();
    }
  }

  function initDrawer() {
    var d = getDrawer();
    if (!d || d.dataset.searchInit === 'true') return;
    d.dataset.searchInit = 'true';

    var closeBtn = d.querySelector('[data-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    d.addEventListener('close', function () {
      document.body.classList.remove('search-drawer-open');
      var panel = d.querySelector('.search-drawer-panel');
      if (panel) panel.classList.remove('is-closing');
      var trigger = document.querySelector('[data-search-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });

    onInput(drawerInput, resultsEl);
  }

  function initTriggers(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('[data-search-trigger]').forEach(function (btn) {
      if (btn.dataset.searchTriggerInit === 'true') return;
      btn.dataset.searchTriggerInit = 'true';
      btn.addEventListener('click', handleTriggerClick);
    });
  }

  function initExpandOutsideClick() {
    document.addEventListener('click', function (e) {
      if (!expandOpen) return;
      var wrap = document.querySelector('[data-search-expand]');
      var trigger = document.querySelector('[data-search-trigger]');
      if (!wrap) return;
      if (wrap.contains(e.target) || (trigger && trigger.contains(e.target))) return;
      closeExpand();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && expandOpen) closeExpand();
    });
  }

  function bindExpandInput(root) {
    var scope = root && root.querySelector ? root : document;
    var expandInput = scope.querySelector('[data-search-expand-input]');
    var expandDropdown = scope.querySelector('[data-search-expand-dropdown]');
    if (expandInput && expandDropdown && expandInput.dataset.searchExpandInit !== 'true') {
      expandInput.dataset.searchExpandInit = 'true';
      onInput(expandInput, expandDropdown);
    }
  }

  function reinitSection(root) {
    if (!root || !root.querySelector) return;
    root.querySelectorAll('[data-search-expand-input]').forEach(function (el) {
      delete el.dataset.searchExpandInit;
    });
    root.querySelectorAll('[data-search-trigger]').forEach(function (el) {
      delete el.dataset.searchTriggerInit;
    });
    initTriggers(root);
    bindExpandInput(root);
  }

  function init() {
    initDrawer();
    initTriggers();
    initExpandOutsideClick();
    bindExpandInput();

    desktopMq.addEventListener('change', function () {
      if (expandOpen && !isExpandMode()) closeExpand();
    });
  }

  return { open: open, close: close, init: init, initTriggers: initTriggers, reinitSection: reinitSection };
})();

Search.init();

document.addEventListener('shopify:section:load', function (event) {
  Search.reinitSection(event.target);
});

document.querySelectorAll('[data-address-edit]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var id = btn.dataset.addressEdit;
    var form = document.getElementById('edit-' + id);
    if (form) form.hidden = !form.hidden;
  });
});


/* =============================================
   Size Chart Toggles
   ============================================= */
(function() {
  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('.unit-toggle');
    if (!toggleBtn) return;
    var wrapper = toggleBtn.closest('.size-chart-wrapper');
    if (!wrapper) return;
    
    var unit = toggleBtn.dataset.unit; // 'inch' or 'cm'
    
    // Update active button
    var buttons = wrapper.querySelectorAll('.unit-toggle');
    buttons.forEach(function(btn) {
      btn.classList.toggle('active', btn === toggleBtn);
    });
    
    // Update wrapper class
    wrapper.classList.remove('show-inch', 'show-cm');
    wrapper.classList.add('show-' + unit);
  });
})();

/* =============================================
   Mega Menu Click behavior
   ============================================= */
(function() {
  function initMegaMenuClick() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var triggerType = header.dataset.megaMenuTrigger || 'hover';
    if (triggerType !== 'click') return;

    var megaMenuItems = header.querySelectorAll('.desk-nav-item.has-mega-menu');
    megaMenuItems.forEach(function(item) {
      var link = item.querySelector('.desk-nav-link');
      var wrapper = item.querySelector('.mega-menu-wrapper');
      if (!link || !wrapper) return;

      if (link.dataset.clickInit === 'true') return;
      link.dataset.clickInit = 'true';

      link.addEventListener('click', function(e) {
        var isOpen = wrapper.classList.contains('is-open');
        if (!isOpen) {
          e.preventDefault();
          e.stopPropagation();
          closeAllMegaMenus();
          wrapper.classList.add('is-open');
          item.classList.add('is-active');
        }
      });
    });
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('.mega-menu-wrapper.is-open').forEach(function(wrapper) {
      wrapper.classList.remove('is-open');
    });
    document.querySelectorAll('.desk-nav-item.is-active').forEach(function(item) {
      item.classList.remove('is-active');
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.desk-nav-item.has-mega-menu')) {
      closeAllMegaMenus();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllMegaMenus();
    }
  });

  initMegaMenuClick();

  /* ─── INFINITE SCROLL & LOAD MORE CONTROLLER ────────────────────────── */
  function initInfiniteScroll() {
    var containers = document.querySelectorAll('[data-infinite-scroll-container]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      if (container.dataset.infiniteScrollInit === 'true') return;
      container.dataset.infiniteScrollInit = 'true';

      var controls = container.querySelector('[data-infinite-scroll-controls]');
      if (!controls) return;

      var mode = controls.dataset.paginationMode || 'infinite_scroll';
      if (mode === 'pagination') return;

      var grid = container.querySelector('.cat-product-grid');
      if (!grid) return;

      var sentinel = controls.querySelector('[data-infinite-scroll-sentinel]');
      var button = controls.querySelector('[data-infinite-scroll-button]');
      var loadingIndicator = controls.querySelector('[data-infinite-scroll-loading]');
      var endIndicator = controls.querySelector('[data-infinite-scroll-end]');
      var btnWrap = controls.querySelector('[data-infinite-scroll-btn-wrap]');
      var btnSpinner = controls.querySelector('[data-btn-spinner]');

      var nextUrl = controls.dataset.nextUrl;
      var isLoading = false;
      var observer = null;

      function loadNextPage() {
        if (!nextUrl || isLoading) return;
        isLoading = true;

        if (loadingIndicator && mode === 'infinite_scroll') {
          loadingIndicator.style.display = 'flex';
        }
        if (button) {
          button.disabled = true;
          if (btnSpinner) btnSpinner.style.display = 'inline-block';
        }

        fetch(nextUrl)
          .then(function(response) {
            if (!response.ok) throw new Error('Network error');
            return response.text();
          })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            var newGrid = doc.querySelector('.cat-product-grid');
            if (newGrid) {
              var newCards = Array.from(newGrid.children);
              newCards.forEach(function(card) {
                grid.appendChild(card);
              });
            }

            var newControls = doc.querySelector('[data-infinite-scroll-controls]');
            var newNextUrl = null;
            if (newControls) {
              newNextUrl = newControls.dataset.nextUrl || null;
            } else {
              var nextLink = doc.querySelector('.collection-pagination a[aria-label*="next"], .collection-pagination-link[aria-label*="next"]');
              if (nextLink) {
                newNextUrl = nextLink.getAttribute('href');
              }
            }

            nextUrl = newNextUrl;
            controls.dataset.nextUrl = nextUrl || '';

            if (!nextUrl) {
              if (observer) {
                observer.disconnect();
                observer = null;
              }
              if (sentinel) sentinel.remove();
              if (btnWrap) btnWrap.style.display = 'none';
              if (loadingIndicator) loadingIndicator.style.display = 'none';
              if (endIndicator) endIndicator.style.display = 'flex';
            } else {
              if (loadingIndicator) loadingIndicator.style.display = 'none';
              if (button) {
                button.disabled = false;
                if (btnSpinner) btnSpinner.style.display = 'none';
              }
            }

            document.dispatchEvent(new CustomEvent('unsized:products:loaded', {
              detail: { container: container, grid: grid }
            }));
          })
          .catch(function(err) {
            console.error('Infinite scroll error:', err);
            if (loadingIndicator) loadingIndicator.style.display = 'none';
            if (button) {
              button.disabled = false;
              if (btnSpinner) btnSpinner.style.display = 'none';
            }
          })
          .finally(function() {
            isLoading = false;
          });
      }

      if (mode === 'infinite_scroll' && sentinel) {
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                loadNextPage();
              }
            });
          }, {
            root: null,
            rootMargin: '400px 0px',
            threshold: 0
          });
          observer.observe(sentinel);
        } else if (button) {
          button.addEventListener('click', loadNextPage);
        }
      } else if (mode === 'load_more' && button) {
        button.addEventListener('click', loadNextPage);
      }
    });
  }

  initInfiniteScroll();

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-infinite-scroll-container]') || event.target.closest('[data-infinite-scroll-container]')) {
      initInfiniteScroll();
    }
  });
})();
